import { cancelPayment } from "@api";
import {
    Button,
    Modal
} from "@components";
import { toast } from "@components/toast/Toast";
import { formatAmount } from "@utils";
import { useState } from "react";

const CancelRequest = ({ isOpen, onClose, onComplete, paymentRequestId, amountRequested, customerName }) => {

  const [submitting, setSubmitting] = useState(false);

  const cancel = async () => {
    setSubmitting(true);
    await cancelPayment(paymentRequestId);
    toast({ description: `Cancelled payment request for ${formatAmount(amountRequested)}` });

    if (onComplete) {
      await onComplete();
    }
    setSubmitting(false);
    onClose();
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Cancel payment request">
      <p className="p-4 ">Are you sure you want to cancel the payment request of {formatAmount(amountRequested)} to {customerName}? This action cannot be undone.</p>
      <div className="flex gap-2 justify-end p-4 ">
        <Button submitting={submitting} onClick={() => onClose()}  color="secondary">Back</Button>
        <Button submitting={submitting} onClick={() => cancel()}  color="danger">Cancel request</Button>
      </div>
    </Modal>
  );
}

export default CancelRequest;